import {Component, OnInit} from '@angular/core';
import {UserService} from "../user.service";
import {LayoutService} from "../../layout/layout.service";

import { CurrentUser  } from 'app/core/model/trjireh-model';

@Component({

  selector: 'sa-login-info',
  templateUrl: './login-info.component.html',
})
export class LoginInfoComponent implements OnInit {

  user = '';
  puesto = '';

  constructor(
    private userService: UserService,
              private layoutService: LayoutService) {
  }

  ngOnInit() {
    // this.userService.getLoginInfo().subscribe(user => {
    //   this.user = user
    // })
    const currentUser: CurrentUser = JSON.parse(localStorage.getItem('currentUser'));
   
    if (currentUser != null){
      this.user = currentUser.nombre + ' ' + currentUser.apellido;
      this.puesto = currentUser.puesto;
    }
    // if (this.currentUser == null){
    //   this.router.navigate(['/auth/login']);
    // }
  }

  toggleShortcut() {
    this.layoutService.onShortcutToggle()
  }

}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/user/login-info/login-info.component.ts